export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-image1-b0e759affa4b58061663f09bee090b80.png";